import { render, staticRenderFns } from "./BranchCheckRecordListAlone.vue?vue&type=template&id=8fcf3cc2&"
import script from "./BranchCheckRecordListAlone.vue?vue&type=script&lang=ts&"
export * from "./BranchCheckRecordListAlone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports